const international = {
  id: "international",
  title: "International Travel & Documentation Support",
  questions: [
    {
      question: "Do you assist with visa documentation and processing guidance?",
      answer: "Yes. We provide complete documentation checklists and coordinate visa application support as per destination requirements."
    },
    {
      question: "Can you manage group visa coordination for corporate movements?",
      answer: "Yes. We streamline documentation collection and submission to ensure timely processing for large groups."
    },
    {
      question: "Do you assist with travel insurance arrangements?",
      answer: "Yes. We coordinate suitable travel insurance options based on destination and travel duration."
    },
    {
      question: "How do you handle passport or documentation errors before travel?",
      answer: "We conduct pre-departure document verification to minimize last-minute issues."
    },
    {
      question: "Can you manage forex coordination for international travel?",
      answer: "Yes. We guide clients with forex arrangements through authorized partners."
    },
    {
      question: "Do you assist with international flight planning and routing?",
      answer: "Yes. We manage optimal flight routing, group fare coordination, and baggage requirements."
    },
    {
      question: "How do you handle multi-country travel documentation?",
      answer: "We prepare structured travel documentation guidance covering visa sequencing and transit requirements."
    },
    {
      question: "Do you provide pre-departure briefings for international groups?",
      answer: "Yes. We share detailed travel notes covering local laws, climate, currency, and emergency contacts."
    },
    {
      question: "What support is available during international travel?",
      answer: "Our coordination team remains accessible for schedule adjustments, emergency assistance, and local partner coordination."
    },
    {
      question: "How do you ensure compliance with international travel regulations?",
      answer: "We stay updated with destination-specific entry norms and coordinate accordingly before departure."
    }
  ]
};

export default international;
